<div class="parallax_img" id="parallax_img"></div>

<portfolio-navigation></portfolio-navigation>

<main id="main">
    <div class="container coming-soon-container text-center px-md-4">
        <span>QUICK INSIGHTS</span>
        <!-- <p class="mt-4 mb-5 p-0">A learning portfolio. Designed for you. Game-changing.</p> -->
        <!-- <img class="img-fluid" src="../../../../assets/images/backgrounds/coming-soon.jpg"> -->
    </div>
    <section id="module" class="module">
        <div class="container p-5 mt-5">
            <div data-aos="fade-up">
                <div class="row module-container justify-content-center" data-aos="fade-up" data-aos-delay="200">
                    <div *ngFor="let resource of resources" class="col-md-6 col-lg-6 col-xl-4 module-item">

                        <!-- Sleep -->
                        <a [routerLink]="['/user/resources/insights/', resource.id]">
                            <div *ngIf="resource.title === 'sleep'" class="module-wrap">
                                <div class="d-flex justify-content-center align-items-center text-center">
                                    <img src="../../../../../../assets/images/insights/play.png" class="play-button">
                                    <img
                                        [defaultImage]="preloaderImage"
                                        [lazyLoad]="sleepImage"
                                        class="module-image"
                                        [id]="'module_image_' + resource.id"
                                        (onStateChange)="moduleImageCallback($event, resource.id)"
                                    >
                                    <div class="d-none description-box" [id]="'description_box_' + resource.id">
                                        Do you sleep poorly?
                                    </div>
                                </div>
                            </div>
                        </a>

                        <!-- Worry -->
                        <a [routerLink]="['/user/resources/insights/', resource.id]">
                            <div *ngIf="resource.title === 'worry'" class="module-wrap">
                                <div class="d-flex justify-content-center align-items-center text-center">
                                    <img src="../../../../../../assets/images/insights/play.png" class="play-button">
                                    <img
                                        [defaultImage]="preloaderImage"
                                        [lazyLoad]="worryImage"
                                        class="module-image"
                                        [id]="'module_image_' + resource.id"
                                        (onStateChange)="moduleImageCallback($event, resource.id)"
                                    >
                                    <div class="d-none description-box" [id]="'description_box_' + resource.id">
                                        Do you worry a lot?
                                    </div>
                                </div>
                            </div>
                        </a>

                        <!-- Stress -->
                        <a [routerLink]="['/user/resources/insights/', resource.id]">
                            <div *ngIf="resource.title === 'stress'" class="module-wrap">
                                <div class="d-flex justify-content-center align-items-center text-center">
                                    <img src="../../../../../../assets/images/insights/play.png" class="play-button">
                                    <img
                                        [defaultImage]="preloaderImage"
                                        [lazyLoad]="stressImage"
                                        class="module-image"
                                        [id]="'module_image_' + resource.id"
                                        (onStateChange)="moduleImageCallback($event, resource.id)"
                                    >
                                    <div class="d-none description-box" [id]="'description_box_' + resource.id">
                                        Are you concerned about ongoing stress?
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>

                    <!-- Breathing -->
                    <div class="col-md-6 col-lg-6 col-xl-4 module-item" *ngIf="!loading">
                        <a [routerLink]="['/user/resources/insights/', 0]">
                            <div class="module-wrap">
                                <div class="d-flex justify-content-center align-items-center text-center">
                                    <img src="../../../../../../assets/images/insights/play.png" class="play-button">
                                    <img
                                        [defaultImage]="preloaderImage"
                                        [lazyLoad]="breathImage"
                                        class="module-image"
                                        id="module_image_0"
                                        (onStateChange)="moduleImageCallback($event, 0)"
                                    >
                                    <div class="d-none description-box" id="description_box_0">
                                        Are you keen to improve your breathing?
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>

        </div>

        <!-- Modal Loader -->
        <modal-loader [modalText]="modalText"></modal-loader>

    </section>
</main>
